// src/components/CancelPage.jsx
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Navbar from './Navbar';
import { getUniversalToken } from '../config/api';

function CancelPage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState(null);
  const [hasToken, setHasToken] = useState(false);

  useEffect(() => {
    const token = getUniversalToken();
    const holaUser = localStorage.getItem('holaUser');
    
    if (token) {
      setHasToken(true);
      if (holaUser) {
        setUser(JSON.parse(holaUser));
      }
    }
    setLoading(false);
  }, []);

  const handleChoosePlan = () => {
    if (hasToken) {
      navigate('/subscribe');
    } else {
      toast.info('Please login to choose a plan');
      navigate('/auth');
    }
  };

  const handleBackHome = () => {
    navigate('/');
  };

  if (loading) {
    return (
      <>
        <Navbar />
        <div className="container text-center py-5" style={{ minHeight: '80vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div>
            <div className="spinner-border text-primary mb-3" style={{ width: '3rem', height: '3rem' }}>
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="text-muted">Loading...</p>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <Navbar />
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-md-10 col-lg-8">
            <div className="card shadow-lg border-0">
              <div className="card-body p-5 text-center">
                
                {/* Cancel Icon - Same style as Success SVG */}
                <div className="cancel-icon mb-4">
                  <svg width="80" height="80" viewBox="0 0 80 80" fill="none">
                    <circle cx="40" cy="40" r="40" fill="#0724ff"/>
                    <path d="M30 30 L50 50 M50 30 L30 50" stroke="white" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>

                <h1 className="fw-bold mb-3">No worries!</h1>
                <p className="lead text-muted mb-4">No charges have been made to your <strong>account</strong></p>

                {/* User Info - Same gradient style */}
                {user && (
                  <div className="bg-gradient-light p-4 rounded-3 mb-4">
                    <div className="row text-start">
                      <div className="col-12 mb-3">
                        <small className="text-muted d-block">Welcome back</small>
                        <strong>{user.fullName || user.email}</strong>
                      </div>
                      <div className="col-12">
                        <small className="text-muted d-block">Status</small>
                        <strong className="text-dark">No active subscription</strong>
                      </div>
                    </div>
                  </div>
                )}

                {/* Features - Same style */}
                <div className="row g-3 mb-5 justify-content-center">
                  <div className="col-6 col-sm-4 col-md-3">
                    <div className="text-center p-3">
                      <i className="bi bi-shield-check display-6 text-dark mb-2 d-block"></i>
                      <small className="text-muted">Secure</small>
                    </div>
                  </div>
                  <div className="col-6 col-sm-4 col-md-3">
                    <div className="text-center p-3">
                      <i className="bi bi-arrow-clockwise display-6 text-dark mb-2 d-block"></i>
                      <small className="text-muted">Retry anytime</small>
                    </div>
                  </div>
                  <div className="col-6 col-sm-4 col-md-3">
                    <div className="text-center p-3">
                      <i className="bi bi-credit-card display-6 text-dark mb-2 d-block"></i>
                      <small className="text-muted">All cards accepted</small>
                    </div>
                  </div>
                </div>

                {/* CTA Buttons - Exact same style */}
                <div className="d-grid gap-2 d-md-flex justify-content-md-center mb-4">
                  <button 
                    onClick={handleChoosePlan}
                    className="btn btn-primary btn-lg px-5"
                  >
                    <i className="bi bi-rocket-takeoff me-2"></i>
                    Choose Plan
                  </button>
                  <button 
                    onClick={handleBackHome}
                    className="btn btn-primary btn-lg px-5"
                  >
                    Back to Home
                  </button>
                </div>

                {/* Email Notice - Same style */}
                <div className="alert alert-info d-flex align-items-center justify-content-center">
                  <i className="bi bi-info-circle fs-4 me-3"></i>
                  <p className="mb-0 small">
                    Ready to unlock powerful features? Choose a plan anytime.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Exact same styles as Step5Success */}
      <style jsx>{`
        .cancel-icon {
          animation: scaleIn 0.5s ease-out;
        }
        .bg-gradient-light {
          background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
        }
        @keyframes scaleIn {
          from { transform: scale(0); opacity: 0; }
          to { transform: scale(1); opacity: 1; }
        }
        @media (max-width: 768px) {
          .card-body { padding: 1.5rem !important; }
          .btn-lg { padding: 0.75rem 2rem !important; font-size: 1rem !important; }
          h1 { font-size: 1.75rem !important; }
        }
      `}</style>
    </>
  );
}

export default CancelPage;
